import loadWebpackModule from 'ps-shared-ui/v4/loadWebpackModule';

// Based on:
// https://github.com/webpack/webpack/issues/11033#issuecomment-834559345
export default async function dynamicImport(name) {
  let config;
  try {
    config = require('../../../../../config.local.js');
  } catch (e) {
    config = require('../../../../../config.js');
  }

  const foundModule = Object.entries(config.microfrontend).find(([r]) => r === `${name}_${config.env}`);
  if (!foundModule) throw new Error(`Module could not be found '${name}'.`);
  const [remoteName, remoteUrl] = foundModule;

  if (!remoteName) throw new Error(`URL not configured for remote '${name}'.`);
  if (remoteUrl.split('@').length !== 2) throw new Error(`URL misconfigured for remote '${name}'`);

  const [moduleName, moduleUrl] = remoteUrl.split('@');

  return await loadWebpackModule(moduleName, moduleUrl);
}
